import { borderRadiusMd, shadowsLg, spacing2x, spacing3x, spacing4x, spacing6x, spacing8x } from "@airhelp/design-tokens";
const baseStyleOverlay = {
    zIndex: "modal",
    background: "greyscale.400",
    opacity: "0.8!important",
};
const baseStyleDialogContainer = (props) => {
    const { isCentered, scrollBehavior } = props;
    return {
        display: "flex",
        zIndex: "modal",
        justifyContent: "center",
        alignItems: isCentered === false ? "flex-start" : "center",
        overflow: scrollBehavior === "inside" ? "scroll" : undefined,
    };
};
const baseStyleDialog = {
    color: "primary.900",
    backgroundColor: "grayscale.100",
    borderRadius: borderRadiusMd,
    boxShadow: shadowsLg,
    margin: "16px",
};
const baseStyleHeader = {
    fontSize: "20px",
    fontWeight: "bold",
    color: "font.primary",
    lineHeight: "base",
    paddingTop: 0,
    paddingBottom: { base: spacing6x, md: spacing8x },
    paddingLeft: {
        base: spacing4x,
        md: spacing8x,
    },
    paddingRight: {
        base: "80px",
        md: "96px",
    },
    marginTop: { base: spacing4x, md: spacing8x },
};
const baseStyleCloseButton = {
    top: { base: spacing4x, md: spacing8x },
    right: { base: spacing4x, md: spacing8x },
    padding: spacing3x,
    width: "unset",
    height: "unset",
    color: "primary.900",
    background: "greyscale.300",
    cursor: "pointer",
    _focus: {
        outline: "none",
    },
    svg: {
        width: spacing4x,
        height: spacing4x,
    },
};
const baseStyleBody = {
    fontWeight: "normal",
    fontSize: "md",
    paddingTop: "none",
    paddingBottom: spacing6x,
    paddingX: {
        base: spacing4x,
        md: spacing8x,
    },
    overflow: "scroll",
    scrollBehavior: "smooth",
    "::-webkit-scrollbar": {
        width: spacing2x,
    },
    "::-webkit-scrollbar-track": {
        background: "greyscale.100",
        borderRadius: borderRadiusMd,
    },
    "::-webkit-scrollbar-thumb": {
        background: "greyscale.400",
        borderRadius: "3xl",
    },
    "::-webkit-scrollbar-thumb:hover": {
        background: { md: "greyscale.400" },
    },
};
const baseStyleFooter = {
    paddingTop: "unset",
    paddingX: {
        base: spacing4x,
        md: spacing8x,
    },
    paddingBottom: {
        base: spacing4x,
        md: spacing8x,
    },
    display: "flex",
    flexDirection: { base: "column", md: "row" },
    gap: spacing2x,
    alignItems: "stretch",
    button: {
        width: {
            base: "100%",
            md: "unset",
        },
    },
};
const baseStyle = (props) => ({
    overlay: baseStyleOverlay,
    dialogContainer: baseStyleDialogContainer(props),
    dialog: baseStyleDialog,
    header: baseStyleHeader,
    closeButton: baseStyleCloseButton,
    body: baseStyleBody,
    footer: baseStyleFooter,
});
const Modal = {
    baseStyle,
};
export default Modal;
